

































































/**
 * External dependencies.
 */
import Component, { mixins } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

/**
 * Internal dependencies.
 */
import IsotopeMixin from '@/mixins/IsotopeMixin.vue'
import PhotosHelperMixin from '@/mixins/PhotosHelperMixin.vue'
import IsotopePhotos from '@/components/account/renderless/IsotopePhotos.vue'
import { isSafariBrowser } from '@/utils/helpers'

@Component({
  components: { IsotopePhotos }
})
export default class ProfileResults extends mixins(PhotosHelperMixin, IsotopeMixin) {
  @Prop(Array) profileResults!: Array<any> | object
  @Prop(Boolean) isMyProfile!: boolean
  @Prop(Boolean) isLoading!: boolean

  isSafariBrowser () {
    return isSafariBrowser()
  }
}
